module.exports = __webpack_public_path__ + "img/save-active.f502b60e.svg";